import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import { baseURL } from "../../../config/api";

export const EditRate = () => {
    const navigate = useNavigate();
    const idNumber = useLocation();

    const [rateUnitData, setRateUnitData] = useState<any>(null);

    const [code, setCode] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [category, setCategory] = useState<string>("duration");
    const [conversionFactor, setConversionFactor] =
        useState<string>("1");
    const [active, setActive] = useState<string>("Yes");

    const [pleaseWaitPopup, setPleaseWaitPopup] =
        useState<boolean>(false);

    useEffect(() => {
        setPleaseWaitPopup(true);

        axios
            .get(`${baseURL}rate-units/${idNumber?.state}`)
            .then((response) => {
                const rateUnit = response?.data?.data;

                setRateUnitData(rateUnit);

                setCode(rateUnit?.code ?? "");
                setName(rateUnit?.name ?? "");
                setCategory(
                    rateUnit?.category ?? "duration"
                );

                setConversionFactor(
                    rateUnit?.conversion_factor != null
                        ? String(rateUnit.conversion_factor)
                        : "1"
                );

                setActive(
                    rateUnit?.is_active
                        ? "Yes"
                        : "No"
                );

                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error fetching rate unit:",
                    error
                );
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);

    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const payload = {
            ...rateUnitData,

            code: code.trim(),
            name: name.trim(),
            category: category.trim(),
            conversion_factor: Number(conversionFactor),
            is_active: active === "Yes"
        };

        await axios
            .put(
                `${baseURL}rate-units/${idNumber?.state}`,
                payload,
                {
                    headers: {
                        "Content-Type":
                            "application/json"
                    },
                    withCredentials: false
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error updating rate unit:",
                    error
                );
            });
    };

    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">

                <div className="w-full bg-white p-4 rounded-md">

                    <h2 className="text-lg font-semibold">
                        Edit Rate Unit
                    </h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={handleSubmit}>

                            <div className="w-full">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Name{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={name}
                                            placeholder="e.g. Hour"
                                            onChange={(e) =>
                                                setName(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Code{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                            required
                                        >
                                            <option value="">
                                                Select Code
                                            </option>

                                            <option value="HOUR">
                                                HOUR
                                            </option>

                                            <option value="DAY">
                                                DAY
                                            </option>

                                            <option value="WEEK">
                                                WEEK
                                            </option>

                                            <option value="MONTH">
                                                MONTH
                                            </option>

                                            <option value="MILE">
                                                MILE
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Category{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={category}
                                            placeholder="e.g. duration"
                                            onChange={(e) =>
                                                setCategory(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Conversion Factor{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={conversionFactor}
                                            placeholder="e.g. 1"
                                            onChange={(e) =>
                                                setConversionFactor(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Active
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={active}
                                            onChange={(e) =>
                                                setActive(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>

                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-6">

                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            navigate(-1)
                                        }
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-white text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                </div>

                            </div>

                        </form>

                    </div>
                </div>
            </div>

            <PleasewaitPopup
                showPopup={pleaseWaitPopup}
            />
        </>
    );
};